const lang={
    en:{
        search:"Search",
        gptsearch:"What would you like to search today?"
    },
    dk:{
        search:"Sørch",
        gptsearch:"Hvad vil du gerne søge i dag"
    }
}
export default lang